import { render, staticRenderFns } from "./LLMchatbotList.vue?vue&type=template&id=5ac28416&scoped=true&"
import script from "./LLMchatbotList.vue?vue&type=script&lang=js&"
export * from "./LLMchatbotList.vue?vue&type=script&lang=js&"
import style0 from "./LLMchatbotList.vue?vue&type=style&index=0&id=5ac28416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac28416",
  null
  
)

export default component.exports